import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    privacy: {
        textAlign: 'center',
        paddingLeft: 20,
        paddingRight : 20 ,
        paddingTop : 20
    },
    drawerHeader: {
        backgroundColor: theme.palette.primary.main
    },
    drawerHeaderIcon: {
        color: theme.palette.primary.contrastText
    }
}))
